





















































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import VueApexCharts from 'vue-apexcharts';
import { Prop } from 'vue-property-decorator';
import { ContactSelection } from '@/modules/contacts/shared/domain/contact-selection';
import { contacts } from '@/modules/shared/shared/store/namespaces';
import { ContactsGetters } from '@/modules/contacts/shared/store/contacts.getters';
import { UserContactTicket } from '@/modules/tickets/shared/domain/user-contact-ticket';

@Component({
    name: 'contact-detail',
    components: {
        apexchart: VueApexCharts,
    },
})
export default class ContactDetail extends Vue {
    @Prop({ required: true })
    contact!: ContactSelection;

    @Prop({ required: true, type: Boolean })
    isDaycohostUser!: boolean;

    @Prop({ required: true, type: Boolean })
    isCustomerManagement!: boolean;

    currentYear: number = -1;

    displayUserStatus(userStatus: string) {
        if (userStatus === 'Activo' || userStatus === 'Pendiente') {
            return 'Acceso al Portal activo';
        } else {
            if (userStatus === 'Inactivo') {
                return 'Acceso al Portal inactivo';
            } else {
                return 'Por crear';
            }
        }
    }

    displayUserStatusColor(userStatus: string) {
        if (userStatus === 'Activo' || userStatus === 'Pendiente') {
            return 'green';
        } else {
            return 'gray';
        }
    }

    displayYears(lastYear: number, currentYear: number) {
        if (lastYear === -1 || currentYear === -1) {
            return '';
        } else {
            if (lastYear === currentYear) {
                return lastYear.toString();
            } else {
                return `${lastYear} - ${currentYear}`;
            }
        }
    }

    displayUsername(email: string) {
        let indexEndOfUsername = email.indexOf('@');
        if (indexEndOfUsername !== -1) {
            return email.slice(0, indexEndOfUsername);
        }
    }

    displayContactCI(CI: string) {
        let CIToDisplay: string = '';
        if (CI[0].toUpperCase() === 'V' || CI[0].toUpperCase() === 'E') {
            CIToDisplay += CI[0].toUpperCase() + '-';
            CI = CI.slice(1);
        }

        let formattedCI = '';
        let reversedCI = CI.split('')
            .reverse()
            .join('');

        [...reversedCI].forEach((character, index) => {
            index % 3 == 0 && index != 0 ? (formattedCI += '.') : false;
            formattedCI += character;
        });

        CIToDisplay += formattedCI
            .split('')
            .reverse()
            .join('');
        return CIToDisplay;
    }

    displayContactNames(lastName: string, name: string) {
        if (lastName) {
            if (name) {
                return lastName + ', ' + name;
            } else {
                return lastName;
            }
        } else {
            if (name) {
                return name;
            } else {
                return 'No especificado';
            }
        }
    }

    get totalTicketsPerMonth(): number[] {
        return this.tickets.map(i => i.total);
    }

    get tickNumbers() {
        let max = Math.max(...this.totalTicketsPerMonth);
        return Math.min(max, 5);
    }

    get graphData() {
        let series_history: any[] = [
            {
                name: 'Tickets',
                data: [],
            },
        ];
        series_history[0].data = this.totalTicketsPerMonth;
        return series_history;
    }

    @contacts.Getter(ContactsGetters.GET_CURRENT_SELECTED_CONTACT_RESOURCES)
    contactPrivileges!: string;

    @contacts.Getter(ContactsGetters.GET_CURRENT_SELECTION)
    selection!: any;

    @contacts.Getter(ContactsGetters.GET_CONTACT_TICKETS)
    tickets!: UserContactTicket[];
}
